import { $http } from '@/utils/https';
import type { Product } from '@/types/shop';

interface State {
  isSamplesLoading: boolean;
  samples: Product[] | null;
  removedSamples: number[];
}

const state: State = {
  isSamplesLoading: false,
  samples: [],
  removedSamples: []
};

const getters = {
  isSamplesLoading: (state: State) => state.isSamplesLoading,
  samples: (state: State) => state.samples,
  removedSamples: (state: State) => state.removedSamples
};

const actions = {
  // eslint-disable-next-line no-unused-vars
  CHECK_SAMPLES: async ({ commit }: any, payload: any) => {
    try {
      commit('CHANGE_SAMPLES_LOADING', true);
      const response = await $http.get<{ data: Product[] }>('v1/products/check-samples', {
        params: payload
      });
      commit('SET_SAMPLES', response.data.data);
      return response.data.data;
    } catch (e) {
      throw e;
    } finally {
      commit('CHANGE_SAMPLES_LOADING', false);
    }
  }
};

const mutations = {
  CHANGE_SAMPLES_LOADING(state: State, status: boolean) {
    state.isSamplesLoading = status;
  },
  SET_SAMPLES(state: State, samples: Product[]) {
    // @ts-ignore
    state.samples = samples.filter((item) => !state.removedSamples.includes(item.id));
  },
  SET_REMOVED_SAMPLER(state: State, sampleId: number) {
    console.log('SET_REMOVED_SAMPLER', sampleId);
    state.removedSamples.push(sampleId);
    // @ts-ignore
    state.samples = state.samples.filter((item) => !state.removedSamples.includes(item.id));
  },
  RESET_REMOVED_SAMPLES(state: State) {
    state.removedSamples = [];
  }
};

//294/100

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
